import { useEffect, useState } from "react";

import { listExclusions } from "../services/stationExclusions";

/** The ids of stations on the owner-alerting exclusion list, read once; empty when the list cannot be read. */
export const useExcludedStations = (): Set<string> => {
  const [excluded, setExcluded] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    let active = true;
    listExclusions()
      .then((exclusions) => {
        if (active) setExcluded(new Set(exclusions.map((e) => e.stationId)));
      })
      .catch(() => {
        if (active) setExcluded(new Set());
      });
    return () => {
      active = false;
    };
  }, []);

  return excluded;
};
